export default __webpack_public_path__ + "static/media/Group 12944.f6d1c9f7.svg";